import { store } from "store";
import { sandboxActionInvoked } from "store/features";
import { SvgAdd } from "@itwin/itwinui-icons-react";
import { MenuItem } from "@itwin/itwinui-react";

export const CreateMenuItem = ({ close }: { close: () => void }) => {

  const onClick = () => {
    store.dispatch(sandboxActionInvoked({
      type: "create",
    }));

    close();
  }

  return (
    <MenuItem
      icon={<SvgAdd />}
      onClick={onClick}
      data-testid="atp-create-new-sandbox"
    >
      Create New Sandbox
    </MenuItem>
  )
}
